import { useEffect, useRef, useState } from "react";

const useAnimationAppear = () => {
  const [applyAnimationAppear, setApplyAnimationAppear] = useState(true);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setApplyAnimationAppear(false);
    }, 1200);

    return function () {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return applyAnimationAppear;
};

export default useAnimationAppear;
